module.exports = __webpack_public_path__ + "static/projekt-opakowania-drdetox-3bcc7af7e04fe6d7fc23a5377c0226f4.png";